import {
	indigo500,
	indigo700,
  grey600,
  pinkA100, pinkA200, pinkA400,
  fullWhite
} from 'material-ui/styles/colors'
import { fade } from 'material-ui/utils/colorManipulator'

export default {
  palette: {
    primary1Color: indigo500,
    primary2Color: indigo700,
    primary3Color: grey600,
    accent1Color: pinkA200,
    accent2Color: pinkA400,
    accent3Color: pinkA100,
    textColor: fullWhite,
    secondaryTextColor: fade(fullWhite, 0.7),
    alternateTextColor: '#303030',
    canvasColor: '#303030',
    borderColor: fade(fullWhite, 0.3),
    disabledColor: fade(fullWhite, 0.3),
    pickerHeaderColor: fade(fullWhite, 0.12),
    clockCircleColor: fade(fullWhite, 0.12)
  }
}



// WEBPACK FOOTER //
// ./src/themes/ics_theme.js